import { getKeyPrefix } from '@nucleus/ncu-key-prefix';

export type CollectionType = 'postCollection' | 'tag' | 'author';

export const getCollectionTypeFromId = (id?: string): CollectionType | undefined => {
  if (id === undefined) {
    return;
  }

  const PrefixPathMap: Record<string, CollectionType> = {
    postcollection: 'postCollection',
    posttopic: 'tag',
    author: 'author',
  };

  const prefix = getKeyPrefix(id);

  if (!prefix) {
    return;
  }

  return PrefixPathMap[prefix];
};
